import { Box, Grid, Text, Textarea } from "@chakra-ui/react";
import {
  EntityProfileTextList,
  entityProfileListToText,
  entityProfileTextToList,
} from "../../../../../entityProfileModal/components/EntityProfilePreferenceControls";
import { entityProfileModalColors } from "../../../../../entityProfileModal/entityProfileModal.theme";
import type { StaffingPreferences, StaffingPreferencesBody } from "../staffingPreferences.types";

type StaffingTextListField = {
  description: string;
  key: "requests" | "tasks";
  title: string;
};

const textListFields: StaffingTextListField[] = [
  {
    key: "requests",
    title: "Special staffing requests",
    description: "Please, indicate here special request brought up by the patient",
  },
  {
    key: "tasks",
    title: "What are the main things the caregiver will do",
    description: "Please, indicate here what are the main tasks that the patients needs help with",
  },
];

export function StaffingTextListFields(props: {
  draft: StaffingPreferencesBody | null;
  preferences: StaffingPreferences;
  onChangeDraft: (draft: StaffingPreferencesBody) => void;
  onCommitDraft: (draft: StaffingPreferencesBody) => void;
}) {
  return (
    <Grid gap={8} templateColumns={{ base: "1fr", lg: "repeat(2, minmax(0, 1fr))" }}>
      {textListFields.map((field) => (
        <Box key={field.key}>
          <Text color={entityProfileModalColors.title} fontSize="18px" fontWeight={600}>
            {field.title}
          </Text>
          <Text color={entityProfileModalColors.muted} fontSize="13px" mb={3}>
            {field.description}
          </Text>
          {props.draft !== null ? (
            <StaffingTextListEditor
              draft={props.draft}
              field={field}
              onChangeDraft={props.onChangeDraft}
              onCommitDraft={props.onCommitDraft}
            />
          ) : (
            <EntityProfileTextList items={props.preferences[field.key]} />
          )}
        </Box>
      ))}
    </Grid>
  );
}

function StaffingTextListEditor(props: {
  draft: StaffingPreferencesBody;
  field: StaffingTextListField;
  onChangeDraft: (draft: StaffingPreferencesBody) => void;
  onCommitDraft: (draft: StaffingPreferencesBody) => void;
}) {
  return (
    <Textarea
      mt={3}
      rows={5}
      value={entityProfileListToText(props.draft[props.field.key])}
      onBlur={(event) =>
        props.onCommitDraft({
          ...props.draft,
          [props.field.key]: entityProfileTextToList(event.currentTarget.value),
        })
      }
      onChange={(event) =>
        props.onChangeDraft({
          ...props.draft,
          [props.field.key]: entityProfileTextToList(event.target.value),
        })
      }
    />
  );
}
